import React, { useEffect, useState } from "react";
import MemoryGame from "./MemoryGame";
import { RiTimerFlashFill } from "react-icons/ri";
import { formatTime } from "../../../utils";

function RecallAndMatch({
  start,
  getStatus,
  getTotal,
  getMatches,
  isReset,
  resetIsReset,
  handleResume,
  getDifficulty,
  timerSeconds,
  timerMinutes,
  timerRunning,
}) {
  const [showSuccessful] = useState(true);
  const [countSuccessful, setCountSuccessful] = useState(0);
  const [gridNumber, setGridNumber] = useState(0);
  const [, setGameFinished] = useState(false);
  const [timesPlayed, setTimesPlayed] = useState(0);

  const styles = {
    container: {
      padding: "10px 20px 20px 20px",
      textAlign: "center",
      color: "black",
    },
    chooseContainer: { padding: 20, fontSize: "1.5rem" },
  };

  useEffect(() => {
    if (isReset) {
      setCountSuccessful(0);
      setGridNumber(0);
      setGameFinished(undefined);
      getMatches && getMatches(0); // Reset match count in parent
      resetIsReset(false);
      setTimesPlayed(timesPlayed + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReset]);

  useEffect(() => {
    if (gridNumber === 4) {
      getTotal(8);
    } else if (gridNumber === 5) {
      getTotal(10);
    } else getTotal(12);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridNumber]);

  return (
    <div style={styles.container}>
      <h1 className="text-2xl font-medium px-12 mb-4 text-white">
        Test Your Memory
      </h1>

      {/* Timer Display - only show when game is active */}
      {!gridNumber && (
        <>
          <h2 className="text-lg text-white">Choose difficulty level:</h2>
          <div style={styles.chooseContainer}>
            <p
              onClick={() => {
                setGridNumber(4);
                getDifficulty && getDifficulty("easy");
                if (timesPlayed === 0) {
                  start();
                } else {
                  handleResume();
                }
              }}
              className="py-2 px-5 bg-primary-main text-white text-center my-3 rounded-3xl"
            >
              Casual
            </p>
            <p
              onClick={() => {
                setGridNumber(5);
                getDifficulty && getDifficulty("medium");
                if (timesPlayed === 0) {
                  start();
                } else {
                  handleResume();
                }
              }}
              className="py-2 px-5 bg-primary-main text-white text-center my-3 rounded-3xl"
            >
              Challenging
            </p>
            <p
              onClick={() => {
                setGridNumber(6);
                getDifficulty && getDifficulty("hard");
                if (timesPlayed === 0) {
                  start();
                } else {
                  handleResume();
                }
              }}
              className="py-2 px-5 bg-primary-main text-white text-center my-3 rounded-3xl"
            >
              Intense
            </p>
          </div>
        </>
      )}
      <div className="flex items-center gap-3 justify-between">
        {gridNumber > 0 && (
          <div className="text-white">
            Matches: {countSuccessful}/{gridNumber * 2}
          </div>
        )}
        {gridNumber > 0 &&
          timerSeconds !== undefined &&
          timerMinutes !== undefined && (
            <div className="flex items-center justify-center gap-1">
              <RiTimerFlashFill className="text-white text-xl" />
              <p className="flex items-center text-white text-lg font-bold">
                <span>{formatTime(timerMinutes)}:</span>
                <span>{formatTime(timerSeconds)}</span>
              </p>
            </div>
          )}
      </div>
      {gridNumber > 0 && showSuccessful && (
        <MemoryGame
          holeCardsColor={"orange"}
          foundCardsColor={"yellow"}
          gridNumber={gridNumber}
          gameFinished={() => {
            const finalMatches = gridNumber * 2; // Total number of pairs
            getMatches && getMatches(finalMatches);
            setGameFinished(true);
            getStatus(true);
          }}
          foundPair={() => {
            if (showSuccessful) {
              setTimeout(() => {
                setCountSuccessful((prev) => {
                  const newCount = prev + 1;
                  getMatches && getMatches(newCount);
                  return newCount;
                });
              }, 200);
            }
          }}
        />
      )}
    </div>
  );
}
export default RecallAndMatch;
